
import * as noneRuntime$VdnVmbn4vb from '/vercel/path0/node_modules/@nuxt/image/dist/runtime/providers/none'
import * as vercelRuntime$b8uWPRx1qM from '/vercel/path0/node_modules/@nuxt/image/dist/runtime/providers/vercel'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "vercel",
  "domains": [
    "carfree-dev.fra1.digitaloceanspaces.com",
    "carfree-prod.fra1.cdn.digitaloceanspaces.com",
    "carfree.s10.renteon.com",
    "carfreeold.s10.renteon.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['none']: { provider: noneRuntime$VdnVmbn4vb, defaults: {} },
  ['vercel']: { provider: vercelRuntime$b8uWPRx1qM, defaults: {} }
}
        